import { cn } from "@/lib/utils";

export interface PartnerBadgeProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md';
  className?: string;
}

export default function PartnerBadge({ 
  variant = 'dark', 
  size = 'sm', 
  className = '' 
}: PartnerBadgeProps) {
  return (
    <div className="relative inline-block group">
      <span 
        aria-label="Amazon Verified Partner"
        className={cn(
          "inline-flex items-center gap-1.5 rounded-full border transition-all duration-300 font-medium relative overflow-hidden cursor-help",
          "bg-gradient-to-r from-orange-500/20 to-amber-500/20 text-orange-400 border-orange-400/40",
          "hover:from-orange-500/30 hover:to-amber-500/30 hover:border-orange-400/60",
          "shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40 group-hover:shadow-orange-500/50",
          "before:absolute before:inset-0 before:bg-gradient-to-r before:from-orange-400/10 before:to-transparent before:blur-sm",
          size === 'sm' ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm",
          className
        )}
      >
        <span className="relative z-10 flex items-center gap-1.5">
          Amazon <strong className="opacity-90">Verified</strong> <strong className="text-orange-300">Partner</strong>
          <span className="w-1.5 h-1.5 bg-orange-400 rounded-full animate-pulse shadow-sm shadow-orange-400/50"></span>
        </span>
      </span>
      
      {/* Tooltip minimaliste */}
      <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 pointer-events-none z-50">
        <div className="bg-transparent backdrop-blur-none border-none p-3 text-center max-w-64">
          <p className="text-xs text-orange-400/90 font-medium leading-relaxed text-justify">
            Certification officielle Amazon permettant la gestion professionnelle des comptes vendeurs, l'optimisation des campagnes publicitaires et l'accès aux APIs avancées de la plateforme e-commerce.
          </p>
        </div>
      </div>
    </div>
  );
}